import {LitElement, html, css} from 'lit-element';


class MediaOembed extends LitElement {
    static get properties () {
        return {
            url: {
                type: String
            },
            /** oembed endpoint, defaults to oembed-api, must end with `url=` */
            provider: {
                type: String
            },
            /** can be provided from parent or will be taken from the call to the url passed in. Used to add twitter (if necessary) **/
            providerName: {
                attribute: 'provider-name',
                type: String
            },
            count: {
                type: Number
            }
        };
    }


    static get styles () {
        return [
            css``
        ];
    }

    constructor () {
        super();

        this.count = 0;
        this.providerName = '';
        this.provider = `${ga_data.site.hosts.gannettCDNAPI}/oembed/assets?api_key=ab9e9f19e653bf5e97d884f9d974fed4&url=`;
        this.url = '';
    }


    handleResponse (response) {
        if (response) {

            // Clear existing content
            this.innerHTML = '';

            // Set provider name
            this.providerName = response.provider_name;

            // Convert response html string to dom node
            let div = document.createElement('DIV');
            div.classList.add('oembed-container');
            div.innerHTML = response.html;

            this.appendChild(div);

            // this._addScripts(div, response.provider_name);

            // Twitter refresh (if applicable)
            if (this.providerName === 'Twitter' && window.twttr && window.twttr.widgets !== undefined) {
                window.twttr.widgets.load(this);
            }

            // GidgitsJS add/refresh
            // if (!document.getElementById('gidgits-js')) {
            //     this._addGidgits();
            // } else if (window.GidgitsJS) {
            //     window.GidgitsJS.refresh();
            // }

            // if (this.resizeBlackList.indexOf(this.providerName) < 0){
            //     this._resize();
            // }
        }
    }

    addTwitter () {
        let twitterThemeTag = document.createElement('meta');
        let widgetsjs = document.createElement('script');
        widgetsjs.src = 'https://platform.twitter.com/widgets.js';
        widgetsjs.charset = 'utf-8';
        widgetsjs.id = 'twitter-wjs';

        // Asynchronous function queue as defined by Twitter's docs
        window.twttr = (function (w) {
            var t = w.twttr || {};
            t._e = [];
            t.ready = function (f) {
                t._e.push(f);
            };
            return t;
        }(window));

        document.getElementsByTagName('head')[0].appendChild(widgetsjs);

        twitterThemeTag.name = 'twitter:widgets:theme';
        twitterThemeTag.content = 'light';
        document.getElementsByTagName('head')[0].appendChild(twitterThemeTag);
    }

    addGidgits () {
        let gidgetsjs = document.createElement('script');
        gidgetsjs.src = 'https://www.gannett-cdn.com/gannett-web/gidgits-js/gidgits.min.js';
        gidgetsjs.charset = 'utf-8';
        gidgetsjs.id = 'gidgits-js';

        document.getElementsByTagName('head')[0].appendChild(gidgetsjs);
    }

    connectedCallback () {
        super.connectedCallback();

        let targetURL = `${this.provider}${encodeURIComponent(this.url)}`;
        
        if (!document.getElementById('gidgits-js')) {
            this.addGidgits();
        } else if (window.GidgitsJS) {
            window.GidgitsJS.refresh();
        }


        if (this.url !== '') {
            if (window.ga_data.utils) {
                window.ga_data.utils.getJSON(targetURL).then(res => {
                    this.handleResponse(res);
                });
            }
        }


        if (this.providerName === 'Twitter' && !document.getElementById('twitter-wjs')) {
            this.addTwitter();
        }
    }


    render () {
        return html`
            <div>
                <slot></slot>
            </div>
        `;
    }
}

customElements.define('media-oembed', MediaOembed);